var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"language",attrs:{"to":_vm.linkUrl}},[_c('span',{staticClass:"label pc"},[_vm._v("Language")]),_vm._v(_vm._s(_vm.langText))])
}
var staticRenderFns = []

export { render, staticRenderFns }